import {Button, Dialog, DialogContent, Grid, InputAdornment, TextField, Typography} from "@mui/material";
import {translate} from "../../translate/translate";
import {Check, Close} from "@mui/icons-material";
import {ErrorMessage, Field, Form, Formik} from "formik";
import {User} from "../../models/account/user";
import {toast} from "react-toastify";
import React from "react";
import {BaseService} from "../../services/base-service";
import {URLS} from "../../services/app-urls";
import {ErrorComponent} from "../error/error.component";
import * as Yup from "yup";


const ChangePasswordComponent = (props: any) => {
    const [confirmPassword, setConfirmPassword] = React.useState<string>("");
    const userService = new BaseService<User>(URLS.USER);

	const schema = Yup.object().shape({
		password: Yup.string().required(),
		confirmPassword: Yup.string().required(),
	});

    return (
        <Dialog fullWidth maxWidth={"xs"} open={props.openProceed} onClose={props.handleCloseDialogProceed}>
            <Grid p={2} container justifyContent="space-between" sx={{backgroundColor: "primary.main"}}>
                <Grid >
                    <Typography sx={{fontWeight: "bold", fontSize: "16px", color: "#ffffff"}}>
                        {translate.t("recoverPassword")}
                    </Typography>
                </Grid>
                <Grid sx={{cursor: "pointer", color: "#ffffff"}}>
                    <Close onClick={() => {
                        props.handleCloseDialogProceed();
                    }}/>
                </Grid>
            </Grid>
            <DialogContent>
                <Grid container flexDirection="column" gap={3}>
                    <Grid >
                        <Formik
                            enableReinitialize
                            initialValues={new User()}
                            validationSchema={schema}
                            onSubmit={(values) => {
                                setTimeout(() => {
                                    if (values.password == values.confirmPassword) {
                                        const user = {
											id: props.object.id,
	                                        new_password: values.password
                                        };
	                                    const objectId = props.object.id ?? "";
                                        userService.changePassword(
		                                        user, objectId, values.confirmPassword, "change_password")
                                            .then(() => {
                                                toast.success(translate.t("successfully_updated"));
	                                            props.handleCloseDialogProceed();
                                            }).catch((error: any) => {
	                                            ErrorComponent(error);
                                            });
                                    } else {
                                        toast.error(translate.t("password_not_match"));
                                    }
                                }, 500);
                            }}>
                            {
                                ({isValid, values, isValidating, errors, touched}) => (
                                    <Form autoComplete="off">
                                        <Grid container p={"3"} spacing={2} direction={"column"}>
                                            <Grid >
                                                <Field
		                                            as={TextField}
		                                            name="password"
		                                            type="password"
		                                            label={translate.t("password")}
		                                            variant={"outlined"}
		                                            fullWidth
		                                            autoFocus={false}
		                                            required={true}
		                                            values={values}
		                                            error={touched.password && Boolean(errors.password)}
		                                            InputProps={{
			                                            maxLength: 104,
			                                            endAdornment: (
				                                            <InputAdornment position="end">
					                                            {touched.password && Boolean(errors.password) && (
						                                            <div className={"required-field"}>
							                                            {translate.t("required_field")}
						                                            </div>
					                                            )}
				                                            </InputAdornment>
			                                            ),
		                                            }}/>
                                            </Grid>
                                            <Grid >
	                                            <Field
		                                            as={TextField}
		                                            name="confirmPassword"
		                                            label={translate.t("confirm_new_password")}
		                                            variant={"outlined"}
		                                            fullWidth
		                                            autoFocus={false}
		                                            required={true}
		                                            values={values}
		                                            type={"password"}
		                                            error={touched.confirmPassword && Boolean(errors.confirmPassword)}
		                                            InputProps={{
			                                            maxLength: 104,
			                                            endAdornment: (
				                                            <InputAdornment position="end">
					                                            {touched.confirmPassword && Boolean(errors.confirmPassword) && (
						                                            <div className={"required-field"}>
							                                            {translate.t("required_field")}
						                                            </div>
					                                            )}
				                                            </InputAdornment>
			                                            ),
		                                            }}/>
                                            </Grid>
                                            <Grid
                                                direction={"row"} container size={12} spacing={1}
                                                sx={{justifyContent: "flex-end"}}>
                                                <Grid >
                                                    <Button
                                                        color="secondary"
                                                        variant="outlined"
                                                        onClick={() => {
                                                            props.handleCloseDialogProceed();
                                                        }}>
                                                        {translate.t("cancel")}
                                                    </Button>
                                                </Grid>
                                                <Grid >
                                                    <Button
	                                                    disabled={!isValid || isValidating || !values.password || !values.confirmPassword}
                                                        startIcon={<Check/>}
                                                        color="success"
                                                        variant="contained"
                                                        type="submit">
                                                        {translate.t("recoverPassword")}
                                                    </Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Form>
                                )}
                        </Formik>
                    </Grid>
                </Grid>
            </DialogContent>
        </Dialog>
    );

};

export default ChangePasswordComponent;

